export function mapper(val, oMin, oMax, nMin, nMax) {
  val = val - oMin
  oMax = oMax - oMin
  nMax = nMax - nMin
  return ( ( val * nMax ) / oMax ) + nMin
}